<template>
  <el-form-item :label="form.cname+':'"
    :key="form.key"
    :prop="prop"
    :rules="rule">
    <el-input-number style="width:100%"
      v-if="status === 'edit'"
      v-model="form.fieldValue"
      :controls="false"
      :precision="0"
      :min="0"></el-input-number>
    <span v-else>{{form.fieldValue || '&nbsp;' }}</span>
  </el-form-item>
</template>

<script>
export default {
  name: 'form-number',
  props: {
    item: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    prop: {
      type: String,
      required: true
    },
    status: {
      type: String,
      default: 'edit'
    }
  },
  computed: {
    form: {
      get () {
        return this.item
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    rule () {
      return [
        {
          required: this.form.mandatory,
          message: this.form.cname + '不能为空',
          trigger: 'blur'
        }
      ]
    }
  }
}
</script>
